<template>
    <DataTable
        data-key="id"
        ref="dt"
        :value="tableData"
        v-model:selection="selectedProducts"
        :paginator="tableData && tableData.length > 0 ? true : false"
        :rows="rowsPerPage"
        :rowsPerPageOptions="rowsPerPageOptions"
        :first="(lazyParam.page - 1) * rowsPerPage || 0"
        :showFilterMenu="true"
        v-model:filters="filters"
        :filters="filters"
        filterDisplay="menu"
        paginatorPosition="both"
        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput RowsPerPageDropdown"
        :currentPageReportTemplate="TR.table_page_info"
        responsiveLayout="scroll"
        :reorderableColumns="false"
        sortMode="multiple"
        :removableSort="true"
        maxConstraints="2"
        exportFilename="download"
        :rowClass="tableRowClass"
        :stripedRows="false"

        :lazy="true"
        :loading="loading"
        :totalRecords="totalRecords"
        @page="onPage($event)"
        @sort="onSort($event)"
        @filter="onFilter($event)"

        :globalFilterFields="tableOptions.globalFilterFields"
    >
        <!-- selectionMode="single1" -->
        <!-- :showGridlines="true" -->
        <template #empty>
            <div class="d-flex justify-content-sm-center">{{TR.emptyFilterMessage}}</div>
        </template>
        <template #loading>{{TR.loading}}</template>
        <template #header>
            <div class="table-header d-flex flex-column flex-sm-row justify-content-start">
                <button
                    type="button"
                    :title="TR.clear"
                    class="mb-2 mb-sm-0 me-sm-4 btn btn-outline-danger"
                    @click="clearFilter()"
                >
                    <i class="fas fa-filter"></i>
                    {{TR.clear}}
                </button>

                <template v-if="tableOptions.header_buttons && tableOptions.header_buttons.length">
                    <template v-for="(btn, bi) in tableOptions.header_buttons" :key="bi">
                        <button
                            v-if="btn.private === undefined || (typeof btn.private === 'function' ? (btn.private(btn) === false ? true : false) : (btn.private === false ? true : false))"
                            :title="btn.title !== undefined ? btn.title : ''"
                            :class="`mb-2 mb-sm-0 me-sm-3 btn ${btn.class}`"
                            @click="btn.eventCallback($event)"
                        >
                            <i :class="btn.icon"></i>
                            {{btn.label}}
                        </button>
                    </template>
                </template>

                <button
                    v-if="tableOptions !== undefined && (tableOptions.export_button !== undefined && tableOptions.export_button == true)"
                    type="button"
                    :title="TR.download"
                    class="mb-2 mb-sm-0 me-1 ms-sm-auto btn btn-outline-primary"
                    @click="exportCSV()"
                >
                    <i class="fas fa-download"></i>
                    {{TR.download}}
                </button>
            </div>
        </template>

        <template #paginatorstart>
            <!-- <button type="button" class="btn"><i class="fas fa-sync ms-3 text-info"></i></button> -->
        </template>
        <template #paginatorend>
            <!-- <button type="button" class="btn"><i class="fas fa-download me-3"></i></button> -->
        </template>

        <!-- selectionMode="multiple" -->
        <Column
            v-if="tableOptions.row_multiple_select !== undefined && tableOptions.row_multiple_select"
            style="width: 3rem;"
            class="text-center"
            :exportable="false"
            :reorderableColumn="false"
        ></Column>

        <Column
            :exportable="false"
            :sortable="false"
            :reorderableColumn="false"
            style="width: 4rem;"
            class="text-center"
            :header="TR.rank"
        >
            <template #body="{index}">{{dt !== null && dt != undefined && dt.d_first !== undefined ? dt.d_first+index+1 : ''}}</template>
        </Column>

        <Column
            v-if="tableOptions.row_buttons !== undefined && tableOptions.row_buttons.filter((e) => e.private === undefined || e.private !== '').length"
            :exportable="false"
            :reorderableColumn="false"
            :header="TR.operation"
            style="width: 10rem;"
            headerClass="text-center"
            bodyClass="text-center d-inline-flex justify-content-center align-items-center btnicon"
        >
            <template #body="{data}">
                <template v-for="(item, index) in tableOptions.row_buttons" :key="index">
                    <button
                        v-if="item.element == undefined && (item.private === undefined || (typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === false ? true : false)))"
                        :class="`me-sm-21 rounded-circle btn ${item.class}`"
                        :title="item.title !== undefined ? item.title : ''"
                        @click="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null"
                    >
                        <i :class="`pt-13 ${item.icon}`"></i>
                        {{item.label}}
                    </button>

                    <div v-else-if="item.element == 'switch' && (item.private === undefined || (typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === false ? true : false)))" class="d-inline-flex align-items-center ms-3">
                        <div class="form-check form-switch d-inline-block mb-0" :class="item.elementClass" :title="item.title !== undefined ? item.title : ''">
                            <input class="form-check-input" :[item.attr]="item.attrValue" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="item.eventCallback(data, $event)" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                        </div>
                    </div>

                    <div v-else-if="item.element == 'checkbox' && (item.private === undefined || (typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === false ? true : false)))" class="d-inline-flex align-items-center ms-3">
                        <div class="form-check ms-3 mb-0" :class="item.elementClass" :title="item.title !== undefined ? item.title : ''">
                            <input :id="'checkbox_' + index" class="form-check-input" :class="item.elementClass" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="item.eventCallback(data, $event)" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                            <label :for="'checkbox_' + index" class="small text-muted ms-1" v-if="item.checkbox_label !== undefined" v-html="typeof item.checkbox_label !== 'function' ? item.checkbox_label : item.checkbox_label(data)"></label>
                        </div>
                    </div>

                </template>
            </template>
            <!-- template #body="{data}">
                <template v-for="(item, index) in tableOptions.row_buttons" :key="index">
                    <button
                        v-if="item.private === undefined || (typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === false ? true : false))"
                        :class="`me-sm-2 btn rounded-circle ${item.class}`"
                        :title="item.title !== undefined ? item.title : ''"
                        @click="typeof item.eventCallback === 'function' ? item.eventCallback(data, $event) : null"
                    >
                        <i :class="`pt-1 ${item.icon}`"></i>
                        {{item.label}}
                    </button>

                    <div v-else-if="item.element == 'switch' && (item.private === undefined || (typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === false ? true : false)))" class="d-inline-flex align-items-center ms-3">
                        <div class="form-check form-switch d-inline-block mb-0" :class="item.elementClass">
                            <input class="form-check-input" :[item.attr]="item.attrValue" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="item.eventCallback(data, $event)" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                        </div>
                    </div>

                    <div v-else-if="item.element == 'checkbox' && (item.private === undefined || (typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === false ? true : false)))">
                        <input :id="'checkbox_' + index" class="form-check-input" :class="item.elementClass" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="item.eventCallback(data, $event)" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                        <label :for="'checkbox_' + index" class="small text-muted ms-1" v-if="item.checkbox_label !== undefined" v-html="typeof item.checkbox_label !== 'function' ? item.checkbox_label : item.checkbox_label(data)"></label>
                    </div>

                </template>
            </template -->
        </Column>

        <template v-if="tableOptions">
            <template v-for="(item, tcindex) in tableOptions.data_table_columns" :key="tcindex">
                    <!-- v-if="item.private === undefined || (typeof item.private === 'function' ? (item.private(item) === false ? true : false) : (item.private === false ? true : false))" -->
                    <!-- v-if="item.private === undefined || item.private" -->
                <Column
                    v-if="item.private_column === undefined ? true : ( item.private_column && item.private_column == true ? false : true)"
                    :field="item.name"
                    :showFilterMatchModes="item.showFilterMatchModes === undefined || item.showFilterMatchModes ? true : false"
                    :header="item.title || item.name"
                    :exportable="item.exportable === undefined || item.exportable ? true : false"
                    :sortable="item.sortable === undefined || item.sortable ? true : false"
                    :dataType="item.data_type !== undefined && item.data_type ? item.data_type : 'text'"
                    :filterMenuStyle="{'width':'16rem'}"
                    :filterField="(item.filter === undefined || item.filter) && item.filter_field ? item.filter_field : item.name"
                    :maxConstraints="G.columnMaxConstraints"
                    :style="item.style || ''"
                    :class="item.class || ''"
                    :headerStyle="item.header_style || ''"
                    :headerClass="item.header_class || ''"
                    :bodyStyle="item.body_style || ''"
                    :bodyClass="item.body_class || ''"
                    :hidden="item.hidden !== undefined ? item.hidden : false"
                >

                    <template v-if="item.element === undefined" #body="{data, index}">
                        <div v-if="item.private !== undefined && typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === undefined || item.private === false ? true : false)">
                            <div v-if="item.filter_mode !== undefined && (item.filter_mode == 'date' || item.filter_mode == 'currency')" :class="item.class || ''">{{G.formatLocale(typeof item.value !== 'function' ? data[item.name] : item.value(data))}}</div>
                            <div v-else v-html="typeof item.value !== 'function' ? data[item.name] : item.value(data)" :class="item.class || ''"></div>
                        </div>
                    <!-- </template>

                    <template #body="{data, index}"> -->
                        <div v-if="item.private !== undefined && typeof item.private === 'function' ? (item.private(data) === false ? true : false) : (item.private === undefined || item.private === false ? true : false)">
                            <div v-if="item.element == 'switch'" class="d-flex justify-content-center">
                                <div class="form-check form-switch" :class="item.elementClass">
                                    <input class="form-check-input" :[item.attr]="item.attrValue" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="item.eventCallback(data, $event)" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                                </div>
                            </div>

                            <div v-else-if="item.element == 'checkbox'">
                                <input :id="'checkbox_' + index" class="form-check-input" :class="item.elementClass" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="item.eventCallback(data, $event)" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                                <label :for="'checkbox_' + index" class="small text-muted ms-1" v-if="item.checkbox_label !== undefined" v-html="typeof item.checkbox_label !== 'function' ? item.checkbox_label : item.checkbox_label(data)"></label>
                            </div>

                            <input v-else-if="item.element == 'text'" class="form-control" :class="item.elementClass" :value="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="item.eventCallback(data, $event)" type="text" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />

                            <button v-else-if="item.element == 'button'" :class="item.elementClass" @[item.eventName]="item.eventCallback(data, $event)" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false">
                                <i v-if="item.icon" :class="item.icon"></i>
                                <span>{{item.text}}</span>
                            </button>
                        </div>
                    </template>

                    <!-- <template #body="{data, index}">
                        <template v-if="item.element === undefined">
                            <div v-if="item.filter_mode !== undefined && (item.filter_mode == 'date' || item.filter_mode == 'currency')" :class="item.class || ''">{{G.formatLocale(typeof item.value !== 'function' ? data[item.name] : item.value(data))}}</div>
                            <div v-else v-html="typeof item.value !== 'function' ? data[item.name] : item.value(data)" :class="item.class || ''"></div>
                        </template>

                        <div v-else-if="item.element == 'switch'" class="d-flex justify-content-center">
                            <div class="form-check form-switch" :class="item.elementClass">
                                <input class="form-check-input" :[item.attr]="item.attrValue" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="item.eventCallback(data, $event)" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                            </div>
                        </div>

                        <div v-else-if="item.element == 'checkbox'">
                            <input :id="'checkbox_' + index" class="form-check-input" :class="item.elementClass" :checked="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="item.eventCallback(data, $event)" type="checkbox" role="switch" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />
                            <label :for="'checkbox_' + index" class="small text-muted ms-1" v-if="item.checkbox_label !== undefined" v-html="typeof item.checkbox_label !== 'function' ? item.checkbox_label : item.checkbox_label(data)"></label>
                        </div>

                        <input v-else-if="item.element == 'text'" class="form-control" :class="item.elementClass" :value="typeof item.value !== 'function' ? data[item.name] : item.value(data)" @[item.eventName]="item.eventCallback(data, $event)" type="text" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false" />

                        <button v-else-if="item.element == 'button'" :class="item.elementClass" @[item.eventName]="item.eventCallback(data, $event)" :disabled="typeof item.disabled !== 'undefined' ? (typeof item.disabled !== 'function' ? data[item.name] : item.disabled(data)) : false">
                            <i v-if="item.icon" :class="item.icon"></i>
                            <span>{{item.text}}</span>
                        </button>

                        <div v-else v-html="typeof item.value !== 'function' ? data[item.name] : item.value(data)" :class="item.class || ''"></div>
                    </template> -->

                    <template
                        v-if="item.filter === undefined || item.filter ? true : false"
                        #filter="{filterModel}"
                    >
                        <InputText
                            v-if="item.filter_mode === undefined || item.filter_mode == 'text'"
                            type="text"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            class="p-column-filter"
                            :placeholder="item.title || ''"
                        />

                        <InputNumber
                            v-else-if="item.filter_mode == 'numeric'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :useGrouping="item.grouping === undefined || item.grouping == true ? true : false"
                            :placeholder="item.title || ''"
                        />

                        <InputNumber
                            v-else-if="item.filter_mode == 'currency'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :useGrouping="item.grouping === undefined || item.grouping == true ? true : false"
                            mode="currency"
                            :currency="store.getCurrency()"
                            :locale="`${store.getLang()}-${store.getLang().toUpperCase()}`"
                            :placeholder="item.title || ''"
                        />

                        <InputNumber
                            v-else-if="item.filter_mode == 'integer'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :useGrouping="item.grouping === undefined || item.grouping == true ? true : false"
                            :max="item.max"
                            :min="item.min"
                            :placeholder="item.title || ''"
                            integeronly
                        />

                        <InputMask
                            v-else-if="item.filter_mode == 'mask'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :mask="item.input_mask !== undefined && item.input_mask != '' ? item.input_mask : '9'"
                            :placeholder="item.input_mask !== undefined && item.input_mask != '' ? item.input_mask : '9'"
                        />

                        <Calendar
                            v-else-if="item.filter_mode == 'date'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :dateFormat="item.filter_format"
                            :showTime="item.showTime === undefined ? true : item.showTime"
                            :showSeconds="item.showSeconds === undefined ? true : item.showSeconds"
                            :stepMinute="item.stepMinute === undefined ? 1 : item.stepMinute"
                            :timeOnly="item.timeOnly !== undefined ? item.timeOnly : false"
                            :hourFormat="item.hourFormat || '24'"
                            :hideOnDateTimeSelect="true"
                            :showButtonBar="true"
                            :placeholder="item.placeholder || item.title || 'dd.mm.yyyy'"
                            :view="item.view_mode ? item.view_mode : 'date'"
                            :maxDate="item.maxDate || null"
                            :minDate="item.minDate || null"
                        />

                        <Dropdown
                            v-else-if="item.filter_mode == 'dropdown'"
                            v-model="filterModel[item.filter_model !== undefined && item.filter_model == 'label' ? 'label' : 'value']"
                            :options="item.dropdown_items"
                            optionValue="value"
                            optionLabel="label"
                            :placeholder="TR.select"
                            class="p-column-filter"
                            :showClear="true"
                        >
                            <template #value="slotProps">
                                <div
                                    :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.value) : item.dropdown_item_class"
                                    v-if="slotProps.value"
                                >{{item.dropdown_items.filter((e) => e.value == slotProps.value)[0].label}}</div>
                                <span v-else>{{slotProps.placeholder}}</span>
                            </template>
                            <template #option="slotProps">
                                <div
                                    :class="item.dropdown_item_class !== undefined && typeof item.dropdown_item_class === 'function' ? item.dropdown_item_class(slotProps.option.value) : item.dropdown_item_class"
                                >{{slotProps.option.label}}</div>
                            </template>
                        </Dropdown>
                    </template>

                    <template
                        v-if="item.filter === undefined || item.filter ? true : false"
                        #filterclear="{filterCallback}"
                    >
                        <Button
                            type="button"
                            icon="fas fa-times"
                            @click="filterCallback();resetFilter(item.filter_field ? item.filter_field : item.name)"
                            class="p-button-outlined p-button-primary"
                        ></Button>
                    </template>
                    <template
                        v-if="item.filter === undefined || item.filter ? true : false"
                        #filterapply="{filterCallback}"
                    >
                        <Button
                            type="button"
                            icon="fas fa-check"
                            @click="filterCallback()"
                            class="p-button-primary"
                        ></Button>
                    </template>
                </Column>
            </template>
        </template>

        <ColumnGroup type="footer" :reorderableColumn="false" v-if="tableOptions.row_total !== undefined && tableOptions.row_total == true && tableOptions.data_table_columns !== undefined">
            <Row>
                <Column
                    :footer="TR.total"
                    :colspan="(tableOptions.row_multiple_select !== undefined && tableOptions.row_multiple_select ? 1 : 0) + 1 + (tableOptions.row_buttons !== undefined && tableOptions.row_buttons.filter((e)=>e.private === undefined || !e.private).length ? 1 : 0)"
                    footerStyle="text-align:right"
                    :reorderableColumn="false"
                />
                <Column v-for="(item, index) in tableOptions.data_table_columns" :key="index" :reorderableColumn="false">
                    <template #footer>
                        <template v-if="typeof tableOptions.row_total_field !== undefined && tableOptions.row_total_field.length ? tableOptions.row_total_field.filter((e) => e === item.name) : false">{{ pageTotal[item.name] }}</template>
                        <!-- <template #footer="{data}" v-if="typeof tableOptions.row_total_field !== undefined && tableOptions.row_total_field.length ? tableOptions.row_total_field.filter((e) => e === item.name) : false">{{ pageTotal[item.name] }}</template> -->
                    </template>
                </Column>
            </Row>
        </ColumnGroup>

    </DataTable>
</template>


<script>
    import { onMounted, ref, watchEffect } from "vue";

    import { useStore } from "@/system_modules/store";
    import moment from "moment-timezone";

    // import { FilterOperator, FilterMatchMode, FilterService } from "primevue/api";
    import { FilterMatchMode, FilterOperator, FilterService } from '@primevue/core/api';

    import { G, ajax } from "@/_common";

    // import Dialog from "primevue/dialog";
    // import FileUpload from "primevue/fileupload";
    // import Toolbar from "primevue/toolbar";
    // import Rating from "primevue/rating";
    // import Textarea from "primevue/textarea";
    // import RadioButton from "primevue/radiobutton";
    // import MultiSelect from "primevue/multiselect";
    import Button from "primevue/button";
    import InputMask from "primevue/inputmask";
    import InputText from "primevue/inputtext";
    import InputNumber from "primevue/inputnumber";
    import Calendar from "primevue/calendar";
    import Column from "primevue/column";
    import DataTable from "primevue/datatable";
    import Dropdown from "primevue/dropdown";
    import Row from "primevue/row";
    import ColumnGroup from "primevue/columngroup";

    export default {
        name: 'DADataTableLazy',
        props: {
            tableOptions: {
                type: Object,
                default(){
                    return {};
                }
            },
            lazyUrl: {
                type: String,
                default: ''
            },
            lazyParam: {
                type: Object,
                default(){
                    return {
                        isDefault: true,
                        page: 1,
                        mainFilters: {},
                        filters: ''
                    };
                }
            },
        },
        components: {
            // Toast,
            // Dialog,
            // FileUpload,
            // Toolbar,
            // Rating,
            // Textarea,
            // RadioButton,
            // MultiSelect,
            Button,
            InputMask,
            InputText,
            InputNumber,
            Column,
            DataTable,
            Dropdown,
            Row,
            ColumnGroup,
            Calendar,

            // InputClear,
        },
        setup(props) {
            const store = useStore();
            const TR = ref({});

            const dt = ref({});
            const editingRows = ref();
            const selectedProducts = ref();
            const filters = ref({});
            const mainFilter = ref({});

            const rowsPerPage = props.lazyParam.rows || G.rowsPerPage;
            const rowsPerPageOptions = G.rowsPerPageOptions;

            const pageTotal = ref({});
            const tableData = ref([]);
            const loading = ref(false);
            const totalRecords = ref(0);
            const lazyParams = ref({
                filters: props.lazyParam.filters || "",
                first: (props.lazyParam.page - 1) * rowsPerPage,
                // multiSortMeta: [],
                originalEvent: {
                    first: (props.lazyParam.page - 1) * rowsPerPage,
                    page: (props.lazyParam.page - 1 ),
                    // pageCount: 14,
                    rows: rowsPerPage
                },
                page: (props.lazyParam.page - 1),
                // pageCount: 14,
                rows: rowsPerPage,
                // sortField: null,
                // sortOrder: null
            });
            const lazyUrlLocal = ref(null);

            onMounted(async () => {
                lazyUrlLocal.value = props.lazyUrl;

                initFilter();

                if( props.lazyParam.isDefault === undefined ){
                    // lazyParams.value = {
                    //     // filters: "",
                    //     first: (props.lazyParam.page - 1) * rowsPerPage,
                    //     // multiSortMeta: [],
                    //     originalEvent: {
                    //         first: (props.lazyParam.page - 1) * rowsPerPage,
                    //         page: (props.lazyParam.page - 1 ),
                    //         // pageCount: 14,
                    //         // rows: 5
                    //     },
                    //     page: (props.lazyParam.page - 1),
                    //     // pageCount: 14,
                    //     // rows: 5,
                    //     // sortField: null,
                    //     // sortOrder: null
                    // };
                }
                else{
                    store.setDataTableParams({page: 1, rows: G.rowsPerPage, mainFilters: {}, filters: ''});
                }

                filters.value = props.lazyParam.mainFilters.global ? props.lazyParam.mainFilters : mainFilter.value;

                await loadLazyData();
            });


            FilterService.register("customFilter", (value, fl) => {
                if (fl === undefined || fl === null) {
                    return true;
                }
                if (value === undefined || value === null) {
                    return false;
                }
                return value.toString() === fl.value.toString();
            });

            watchEffect(() => {
                TR.value = store.getTranslation();

                props.tableOptions.globalFilterFields = props.tableOptions.data_table_columns
                    .reduce(
                        (acc, cur) => cur.name == "create_date" || cur.name == "update_date" ? acc : [...acc, cur.name],
                        []
                    );
            });

            const clearFilter = () => {
                // lazyParams.value = {};
                // lazyParams.value.first = 0;

                dt.value.d_first = 0;

                store.setDataTableParams({page: 1, rows: G.rowsPerPage, mainFilters: {}, filters: ''});

                lazyParams.value = {
                    filters: "",
                    first: 0,
                    // multiSortMeta: [],
                    originalEvent: {
                        first: 0,
                        page: 0,
                        // pageCount: 14,
                        rows: rowsPerPage
                    },
                    page: 0,
                    // pageCount: 14,
                    rows: rowsPerPage,
                    // sortField: null,
                    // sortOrder: null
                };

                filters.value = mainFilter.value;
                loadLazyData();
            };

            const resetFilter = (field) => {
                filters.value[field] = mainFilter.value[field];
            };
            const initFilter = () => {
                mainFilter.value = {
                    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                };
                if( props.tableOptions && props.tableOptions.data_table_columns ){
                    props.tableOptions.data_table_columns.forEach((e) => {
                        if (e.filters !== undefined)
                            mainFilter.value[e.filter_field ? e.filter_field : e.name] = e.filters;
                        else if (e.filter === undefined || e.filter) {
                            mainFilter.value[e.filter_field ? e.filter_field : e.name] = {
                                operator: FilterOperator.OR,
                                constraints: [
                                    {
                                        value: null,
                                        matchMode: FilterMatchMode.STARTS_WITH,
                                    },
                                ],
                            };
                        }
                    });
                }
                // BETWEEN: "between"
                // CONTAINS: "contains"
                // DATE_AFTER: "dateAfter"
                // DATE_BEFORE: "dateBefore"
                // DATE_IS: "dateIs"
                // DATE_IS_NOT: "dateIsNot"
                // ENDS_WITH: "endsWith"
                // EQUALS: "equals"
                // GREATER_THAN: "gt"
                // GREATER_THAN_OR_EQUAL_TO: "gte"
                // IN: "in"
                // LESS_THAN: "lt"
                // LESS_THAN_OR_EQUAL_TO: "lte"
                // NOT_CONTAINS: "notContains"
                // NOT_EQUALS: "notEquals"
                // STARTS_WITH: "startsWith"
            };

            const exportCSV = () => {
                // dt.value.exportCSV();
            };

            const pageTotal1 = (field) => {
                let total = 0;
                if (tableData.value.length) {
                    for (let p of tableData.value) {
                        total += p[field] || 0;
                    }
                }
                pageTotal.value[field] = G.formatLocale(total);
                // if (currentPageItems.value.length) {
                //     for (let p of currentPageItems.value) {
                //         total += p[field] || 0;
                //     }
                // }
                // pageTotal.value[field] = G.formatLocale(total);
            };

            const loadLazyData = async () => {
                if( lazyUrlLocal.value  ){
                    loading.value = true;

                    // const sortField1 = lazyParams.value ? Object.keys(lazyParams.value).map(k => encodeURIComponent(k) + '=' + encodeURIComponent(lazyParams.value[k])).join('&') : '';

                    const sortField = Object.keys(lazyParams.value).length && lazyParams.value.multiSortMeta !== undefined ? lazyParams.value.multiSortMeta.map(k => encodeURIComponent(k.field) + ',' + encodeURIComponent(k.order)).join('|') : '';

                    const filters = Object.keys(lazyParams.value).length && lazyParams.value.filters !== undefined ? lazyParams.value.filters : '';

                    await ajax({
                        url: lazyUrlLocal.value + `?first=${lazyParams.value.first||0}&rows=${lazyParams.value.rows||5}&sortField=${sortField}&filters=${filters}`,
                        success: (e) => {
                            let res = e.data || null;
                            if( res && e.status == 200 ) {
                                loading.value = false;
                                totalRecords.value = res.total_records;
                                res.data.forEach(x => x.create_date ? x.create_date = new Date(moment.utc(x.create_date).tz(G.systemData.timezone?.value).format(G.datetime_format['pg_datetime'])) : x.create_date );
                                res.data.forEach(x => x.update_date ? x.update_date = new Date(moment.utc(x.update_date).tz(G.systemData.timezone?.value).format(G.datetime_format['pg_datetime'])) : x.update_date );
                                // res.data.forEach(x => x.entry_date ? x.entry_date = new Date(moment.utc(x.entry_date).tz(G.systemData.timezone?.value).format(G.datetime_format['pg_datetime'])) : x.entry_date );
                                // res.data.forEach(x => x.create_date ? x.create_date = new Date(x.create_date) : x.create_date );
                                // res.data.forEach(x => x.update_date ? x.update_date = new Date(x.update_date) : x.update_date );
                                // res.data.forEach(x => x.entry_date ? x.entry_date = new Date(x.entry_date) : x.entry_date );
                                tableData.value = res.data;
                            }
                        },
                    }).then(() => {
                        loading.value = false;
                    });

                    reCalculateTotal();
                }
            };

            const reCalculateTotal = () => {
                if( props.tableOptions && props.tableOptions.row_total_field ){
                    props.tableOptions.row_total_field.forEach((field) => {
                        pageTotal1(field);
                    });
                }
            };

            const onPage = (event) => {
                lazyParams.value = event;
                generateParams(event.filters);
                loadLazyData();
            };
            const onSort = (event) => {
                lazyParams.value = event;
                // // Multiple sort object
                // console.log(event.multiSortMeta);
                generateParams(event.filters);
                loadLazyData();
            };
            const onFilter = () => {
                lazyParams.value.first = 0;
                generateParams(filters.value);
                loadLazyData();
            };

            const generateParams = (FILT) => {
                let x = [];
                for( var a in FILT ){
                    if( a != 'global' ){
                        let c = [];
                        let val;
                        FILT[a].constraints.forEach((b) => {
                            if( b.value != null ){
                                val = a.match(/create_date|update_date|entry_date/mgi) ? G.formatDateLocale(b.value) : b.value;
                                // val = b.value;
                                c.push([ b.matchMode, a, val ].join('|'));
                                // c.push([ b.matchMode, a, moment(b.value).format(G.datetime_format['datetime']) ].join('|'));
                            }
                        });
                        if( c.length ){
                            let z = '';
                            if( c.length > 1 )
                                z = FILT[a].operator + '$$'
                            x.push(z + c.join('$|$'));
                        }
                    }
                }
                // for( var a in filters.value ){
                //     if( a != 'global' ){
                //         let c = [];
                //         filters.value[a].constraints.forEach((b) => {
                //             if( b.value != '' && b.value != null )
                //                 c.push({'value': b.value, 'matchMode': b.matchMode});
                //         });
                //         if( c.length )
                //             x.push(c);
                //     }
                // }
                lazyParams.value.filters = x.join('@|@');
            };

            const tableRowClass = (data) => {
                // // return data.status === 0 ? 'bg-danger text-light': (data.status === 2 ? 'bg-warning text-light': data.status < 0 ? 'bg-secondary text-light' : '');
                // let rc = data.status === 0 ? 'bg-danger text-light': (data.status === 2 ? 'bg-warning text-light': data.status < 0 ? 'bg-secondary text-light' : '');
                // rc += props.tableOptions.row_class !== undefined && typeof props.tableOptions.row_class === 'function' ? props.tableOptions.row_class(data) : (props.tableOptions.row_class !== undefined ? ` ${props.tableOptions.row_class}` : '');

                let rc = [];
                rc.push(data.status == 0 || data.status == false ? 'bg-danger bg-opacity-25 text-secondary text-opacity-50': (data.status == 2 ? 'bg-dark bg-opacity-25': data.status < 0 ? 'bg-dark bg-opacity-75 text-light' : ''));
                rc.push(((props.tableOptions.row_class !== undefined && typeof props.tableOptions.row_class === 'function') ? props.tableOptions.row_class(data) : (props.tableOptions.row_class !== undefined ? ` ${props.tableOptions.row_class}` : '')))
                return rc.join(' ');
            };


            return {
                G,
                TR,
                store,
                dt,

                tableData,
                loading,
                totalRecords,
                lazyParams,
                // lazyUrl,
                onPage,
                onSort,
                onFilter,


                editingRows,
                rowsPerPage,
                rowsPerPageOptions,
                selectedProducts,
                filters,
                exportCSV,

                clearFilter,
                resetFilter,
                pageTotal,
                loadLazyData,
                tableRowClass,
                reCalculateTotal,
            };
        },
    };
</script>


<style lang="scss" scoped>
.form-check{
    min-height: 0px;
}
.btnicon button{
    width: 38px;
    height: 38px;
    text-align: center;
}
.btnicon i{
    width: 16px;
    height: 16px;
}
</style>
